import axios, { AxiosRequestConfig } from 'axios';
import AppConfig from '../config';
import { useAuth0 } from "@auth0/auth0-react";

const ApiClient = () => {

    const { getAccessTokenSilently, isAuthenticated, isLoading } = useAuth0();

    const getConfig = async (): Promise<AxiosRequestConfig> => {
        if (isLoading) {
            throw new Error('Authentication is still loading. Please wait a moment and try again.');
        }
        if (!isAuthenticated) {
            throw new Error('Not signed in. Log in to continue.');
        }

        const token = await getAccessTokenSilently({
            audience: AppConfig.ApiAudience,
            scope: AppConfig.NirvanaRequiredPermissions,
        });

        if (!token) {
            throw new Error('No access token available.');
        }

        return {
            headers: {
                Authorization: `Bearer ${token}`,
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        };
    };


    const get = async <T>(url: string) => {
        let config = await getConfig();
        return axios.get<T>(url, config);
    }

    const post = async <T>(url: string, data?) => {        
        let config = await getConfig();
        return axios.post<T>(url, data, config);
    }

    const deleteRecords = async <T>(url: string) => {        
        let config = await getConfig();
        return axios.delete<T>(url, config);
    }

    const put = async <T>(url: string, data?) => {       
        let config = await getConfig();
        return axios.put<T>(url, data, config);
    }

    return {
        get,
        post,
        deleteRecords,
        put
    }


}

export default ApiClient;

